let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kVX56"), load("izbMG")]).then(() => parcelRequire('frQmB'));